import React from "react";

import PrimaryButton from "../../../../../../../../components/Buttons/PrimaryButton";
import ConfirmDeleteModal from "../../../../../../../../components/BaseDialog/components/ConfirmDeleteModal";


const ResendResultButton = ({name, onResendResultClick, isNewDesign}) => {
  const [confirmOpen, setConfirmOpen] = React.useState(false);

  const handleClose = () => setConfirmOpen(false);

  const title = `${name} neu ermitteln`;

  return(
    <>
      <PrimaryButton
        text={title}
        color={isNewDesign ? 'secondary' : 'primary'}
        variant={"outlined"}
        onButtonClick={() => setConfirmOpen(true)}
      />
      <ConfirmDeleteModal
        open={confirmOpen}
        title={title}
        handleClose={handleClose}
        deleteTitle={'Ja, neu ermitteln'}
        onDeleteClick={onResendResultClick}
      >Möchten Sie das {name} wirklich neu ermitteln?</ConfirmDeleteModal>
    </>
  )
};

export default ResendResultButton;